<!--
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-08-01 17:51:15
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2023-08-04 09:13:15
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "CityManage",
};
</script>
